import { Ionicons } from '@expo/vector-icons'
import * as Font from 'expo-font'
import { useEffect, useState } from 'react'

import { checkForUpdates } from '~utils'

export const useCachedResources = (): boolean => {
  const [isLoadingComplete, setLoadingComplete] = useState(false)

  useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        // Load fonts
        await Font.loadAsync({
          ...Ionicons.font,
          'Manrope-Bold': require('assets/fonts/Manrope-Bold.ttf'),
          'Manrope-Light': require('assets/fonts/Manrope-Light.ttf'),
          'Manrope-Medium': require('assets/fonts/Manrope-Medium.ttf'),
          'Manrope-Regular': require('assets/fonts/Manrope-Regular.ttf'),
          'Roboto-Bold': require('assets/fonts/Roboto-Bold.ttf'),
          IcoMoon: require('~assets/icomoon/icomoon.ttf'),
        })
        await checkForUpdates(true)
      } catch (e) {
        console.warn(e)
      } finally {
        setLoadingComplete(true)
      }
    }

    loadResourcesAndDataAsync()
  }, [])

  return isLoadingComplete
}
